import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import scrollToComponent from 'react-scroll-to-component';

import * as locations from '../../../../constants/covidlocations';

import {messageTextValidation, nameValidation, emailValidation, phoneValidation, locationValidation} from '../../../../utils/itemValidation';

import {PRIMARY_CUSTOMER_SERVICE} from '../../../../constants/contacts';

// import * as headerActionCreators from '../../../actions/header';
let allActionCreators = Object.assign({});

import RhinoSelect from '../../../common/inputs/RhinoSelect';


class Covid19 extends React.Component {

	static propTypes = {
		location: PropTypes.object
	};

	static contextTypes = {
		store: PropTypes.any,
		router: React.PropTypes.object.isRequired
	};

	constructor(props) {
		super(props);

		const firstEntry = [{display: 'Select location', 'value': ''}];
		let newArray= firstEntry.concat(locations.locations);

		this.state = {
			locations: newArray,
			dropdownValue: null,
			openDrawers: [],

      inputName: '',
      inputEmail: '',
      inputPhone: '',
      inputLocation: '',
      inputMessage: '',

      errorName: null,
      errorEmail: null,
      errorPhone: null,
      errorLocation: null,
      errorMessage: null,

      formOpen: false,
		}
	}

	internalNav(page) {
		this.context.router.push('/' + page);
	}

	externalNav(page) {
		window.location.href = '/' + page;
	}

	openNew(page) {
		let win = window.open(page, '_blank');
		win.focus();
	}

	openIntercom() {
    acquireIO.max();
  }

  changeName(evt) {
    this.setState({ inputName: evt.target.value }, () => {
      if(this.state.errorName && !nameValidation(this.state.inputName)) {
        this.setState({ errorName: null });
      }
    });
  }

  changeEmail(evt) {
    this.setState({ inputEmail: evt.target.value }, () => {
      if(this.state.errorEmail && !emailValidation(this.state.inputEmail)) {
        this.setState({ errorEmail: null });
      }
    });
  }

  changePhone(evt) {
    this.setState({ inputPhone: evt.target.value }, () => {
      if(this.state.errorPhone && !phoneValidation(this.state.inputPhone)) {
        this.setState({ errorPhone: null });
      }
    });
  }

  changeLocation(evt) {
    this.setState({inputLocation: evt.target.value}, () => {
      if(this.state.errorLocation !== false && location !== '') {
        this.setState({errorLocation: null});
      }
    });
  }  

  changeMessage(evt) {
    this.setState({ inputMessage: evt.target.value }, () => {
      if(this.state.errorMessage && !messageTextValidation(this.state.inputMessage)) {
        this.setState({ errorMessage: null });
      }
    });
  }

  validateAll() {
    let hasErrors = true;
    
    // Required params
    let nameError = nameValidation(this.state.inputName);
    let emailError = emailValidation(this.state.inputEmail);
    let messageError = messageTextValidation(this.state.inputMessage);
    let locationError = locationValidation(this.state.inputLocation);

    // Optional params
    let phoneError = null;
    if(this.state.inputPhone) {
      phoneError = phoneValidation(this.state.inputPhone);
    }

    if(nameError === null &&
       emailError === null &&
       phoneError === null &&
       locationError === null &&
       messageError === null) {
      hasErrors = false;
    }

    this.setState({
      errorName: nameError,
      errorEmail: emailError,
      errorPhone: phoneError,
      errorLocation: locationError,
      errorMessage: messageError
    });

    return !hasErrors;
  }

  submitContactRequest() {
    if(this.validateAll()) {

      let contactData = {
        full_name: this.state.inputName,
        email: this.state.inputEmail,
        phone: this.state.inputPhone,
        location: this.state.inputLocation,
        message: this.state.inputMessage,
      }

      this.props.commonContactRequest(contactData)
      .then(() => {
        this.context.router.push('/thank-you');
        // this.props.commonAlert('Thank you for submitting a request! A member of our team will follow up with you shortly to finalize your virtual appointment.', 'Continue Browsing', 'helping', '');
      });
      this.setState({
        inputName: '',
        inputEmail: '',
        inputPhone: '',
        inputLocation: '',
        inputMessage: '',
        errorName: null,
        errorEmail: null,
        errorPhone: null,
        errorLocation: null,
        errorMessage: null,
      });
      this.props.commonCloseContact();
    }
  }

	showStoreSection() {
		switch (this.state.dropdownValue) {
			case null:
				// return this.nullResult();
				return null;
			case '':
				return this.nullResult();
			case 'atx':
				return this.atxResult();
			case 'bhm':
				return this.bhmResult();
			case 'boc':
				return this.bocResult();
			case 'chs':
				return this.chsResult();
			case 'clt':
				return this.cltResult();
			case 'cle':
				return this.cleResult();
			case 'coh':
				return this.cohResult();
			case 'dfw':
				return this.dfwResult();
			case 'ftx':
				return this.ftxResult();
			case 'gsc':
				return this.gscResult();
			case 'hou':
				return this.houResult();
			case 'ind':
				return this.indResult();
			case 'jax':
				return this.jaxResult();
			case 'kcy':
				return this.kcyResult();
			case 'nol':
				return this.nolResult();
			case 'okc':
				return this.okcResult();
			case 'pit':
				return this.pitResult();
			case 'ral':
				return this.ralResult();
			case 'rva':
				return this.rvaResult();
			case 'stl':
				return this.stlResult();
			case 'slc':
				return this.slcResult();
			case 'san':
				return this.sanResult();
			case 'vab':
				return this.vabResult();
			default:
				return this.allResult();
		}
	}

	chsResult() {
		return <div className='locationWrapper'>
			<div className='covidP covidPIndent covidLocation' style={{display: 'none'}}>Charleston, SC</div>
			<div className='covidP covidPIndent'>
				<ul className='primaryList'>
					<li>This location is open and operating at a limited capacity to ensure the health and safety of our customers and employees.</li>
					<li>In-store walk-ins are welcome. To request an in-store or virtual appointment for this location <span onClick={::this.scrollToContact} className='scrollLink'>click here</span>.</li>
					<li>Contactless curbside pick-up is available. Please contact us to coordinate.</li>
					<li>Our team is standing by to help ensure the Diamonds Direct experience fits your needs in these unprecedented times.
						<ul>
							<li><a href='tel:8436062558'>843-606-2558</a></li>
							<li><a href='mailto:infoCHS@diamondsdirect.com'>infoCHS@diamondsdirect.com</a></li>
							<li className='chatLink' onClick={::this.openIntercom}>Chat Now</li>
						</ul>
					</li>
				</ul>
			</div>
		</div>;
	}

	allResult() {
		return <div className='locationWrapper'>
			<div className='covidP covidPIndent covidLocation' style={{display: 'none'}}>All other locations</div>
			<div className='covidP covidPIndent'>
				<ul className='primaryList'>
					<li><span style={{color: '#FF0000'}}>Virtual and remote shopping services are available for these locations.</span> Click <a href='/virtual'>HERE</a> to initiate an appointment.</li>
					<li>Free shipping is available for purchases made online and via phone.</li>
					<li>Free shipping is available for select completed orders and repairs. To learn if your order qualifies for shipping, please email us at <a href='mailto:remoteservice@diamondsdirect.com'>remoteservice@diamondsdirect.com</a> or call us at <a href='tel:8008855050'>1-800-885-5050</a>.</li>
					<li>At this time, we cannot accept repairs or accommodate in-store shopping at these locations.</li>
				</ul>
			</div>
		</div>
	}

	okcResult() {
		return <div className='locationWrapper'>
			<div className='covidP covidPIndent covidLocation' style={{display: 'none'}}>Oklahoma City, OK</div>
			<div className='covidP covidPIndent'>
				<ul className='primaryList'>
					<li>This location is open and operating at a limited capacity to ensure the health and safety of our customers and employees.</li>
					<li>In-store walk-ins are welcome. To request an in-store or virtual appointment for this location <span onClick={::this.scrollToContact} className='scrollLink'>click here</span>.</li>
					<li>Contactless curbside pick-up is available. Please contact us to coordinate.</li>
					<li>Our team is standing by to help ensure the Diamonds Direct experience fits your needs in these unprecedented times.
						<ul>
							<li><a href='tel:4056088802'>405-608-8802</a></li>
							<li><a href='mailto:infoOKC@diamondsdirect.com'>infoOKC@diamondsdirect.com</a></li>
							<li className='chatLink' onClick={::this.openIntercom}>Chat Now</li>
						</ul>
					</li>
				</ul>
			</div>
		</div>
	}

	atxResult() {
		return <div className='locationWrapper'>
			<div className='covidP covidPIndent covidLocation' style={{display: 'none'}}>Austin, TX</div>
			<div className='covidP covidPIndent'>
				<ul className='primaryList'>
					<li>This location is open and operating at a limited capacity to ensure the health and safety of our customers and employees.</li>
					<li>In-store walk-ins are welcome. To request an in-store or virtual appointment for this location <span onClick={::this.scrollToContact} className='scrollLink'>click here</span>.</li>
					<li>Contactless curbside pick-up is available. Please contact us to coordinate.</li>
					<li>Our team is standing by to help ensure the Diamonds Direct experience fits your needs in these unprecedented times.
						<ul>
							<li><a href='tel:5126919950'>512-691-9950</a></li>
							<li><a href='mailto:infoAUS@diamondsdirect.com'>infoAUS@diamondsdirect.com</a></li>
							<li className='chatLink' onClick={::this.openIntercom}>Chat Now</li>
						</ul>
					</li>
				</ul>
			</div>
		</div>
	}

	bhmResult() {
		return <div className='locationWrapper'>
			<div className='covidP covidPIndent covidLocation' style={{display: 'none'}}>Birmingham, AL</div>
			<div className='covidP covidPIndent'>
				<ul className='primaryList'>
					<li>This location is open and operating at a limited capacity to ensure the health and safety of our customers and employees.</li>
					<li>In-store walk-ins are welcome. To request an in-store or virtual appointment for this location <span onClick={::this.scrollToContact} className='scrollLink'>click here</span>.</li>
					<li>Contactless curbside pick-up is available. Please contact us to coordinate.</li>
					<li>Our team is standing by to help ensure the Diamonds Direct experience fits your needs in these unprecedented times.
						<ul>
							<li><a href='tel:2052017400'>205-201-7400</a></li>
							<li><a href='mailto:infoBHM@diamondsdirect.com'>infoBHM@diamondsdirect.com</a></li>
							<li className='chatLink' onClick={::this.openIntercom}>Chat Now</li>
						</ul>
					</li>
				</ul>
			</div>
		</div>
	}

	bocResult() {
		return <div className='locationWrapper'>
			<div className='covidP covidPIndent covidLocation' style={{display: 'none'}}>Boca Raton, FL</div>
			<div className='covidP covidPIndent'>
				<ul className='primaryList'>
					<li>This location is open and operating at a limited capacity to ensure the health and safety of our customers and employees.</li>
					<li>In-store walk-ins are welcome. To request an in-store or virtual appointment for this location <span onClick={::this.scrollToContact} className='scrollLink'>click here</span>.</li>
					<li>Contactless curbside pick-up is available. Please contact us to coordinate.</li>
					<li>Our team is standing by to help ensure the Diamonds Direct experience fits your needs in these unprecedented times.
						<ul>
							<li><a href='tel:5614142091'>561-414-2091</a></li>
							<li><a href='mailto:infoBoca@diamondsdirect.com'>infoBoca@diamondsdirect.com</a></li>
							<li className='chatLink' onClick={::this.openIntercom}>Chat Now</li>
						</ul>
					</li>
				</ul>
			</div>
		</div>
	}

	cltResult() {
		return <div className='locationWrapper'>
			<div className='covidP covidPIndent covidLocation' style={{display: 'none'}}>Charlotte, NC</div>
			<div className='covidP covidPIndent'>
				<ul className='primaryList'>
					<li>This location is open and operating at a limited capacity to ensure the health and safety of our customers and employees.</li>
					<li>In-store walk-ins are welcome. To request an in-store or virtual appointment for this location <span onClick={::this.scrollToContact} className='scrollLink'>click here</span>.</li>
					<li>Contactless curbside pick-up is available. Please contact us to coordinate.</li>
					<li>Our team is standing by to help ensure the Diamonds Direct experience fits your needs in these unprecedented times.
						<ul>
							<li><a href='tel:7045329041'>704-532-9041</a></li>
							<li><a href='mailto:infoclt@diamondsdirect.com'>infoclt@diamondsdirect.com</a></li>
							<li className='chatLink' onClick={::this.openIntercom}>Chat Now</li>
						</ul>
					</li>
				</ul>
			</div>
		</div>
	}

	cleResult() {
		return <div className='locationWrapper'>
			<div className='covidP covidPIndent covidLocation' style={{display: 'none'}}>Cleveland, OH</div>
			<div className='covidP covidPIndent'>
				<ul className='primaryList'>
					<li>This location is open and operating at a limited capacity to ensure the health and safety of our customers and employees.</li>
					<li>In-store walk-ins are welcome. To request an in-store or virtual appointment for this location <span onClick={::this.scrollToContact} className='scrollLink'>click here</span>.</li>
					<li>Contactless curbside pick-up is available. Please contact us to coordinate.</li>
					<li>Our team is standing by to help ensure the Diamonds Direct experience fits your needs in these unprecedented times.
						<ul>
							<li><a href='tel:2162732812'>216-273-2812</a></li>
							<li><a href='mailto:infoCLE@diamondsdirect.com'>infoCLE@diamondsdirect.com</a></li>
							<li className='chatLink' onClick={::this.openIntercom}>Chat Now</li>
						</ul>
					</li>
				</ul>
			</div>
		</div>
	}

	cohResult() {
		return <div className='locationWrapper'>
			<div className='covidP covidPIndent covidLocation' style={{display: 'none'}}>Columbus, OH</div>
			<div className='covidP covidPIndent'>
				<ul className='primaryList'>
					<li>This location is open and operating at a limited capacity to ensure the health and safety of our customers and employees.</li>
					<li>In-store walk-ins are welcome. To request an in-store or virtual appointment for this location <span onClick={::this.scrollToContact} className='scrollLink'>click here</span>.</li>
					<li>Contactless curbside pick-up is available. Please contact us to coordinate.</li>
					<li>Our team is standing by to help ensure the Diamonds Direct experience fits your needs in these unprecedented times.
						<ul>
							<li><a href='tel:6145160515'>614-516-0515</a></li>
							<li><a href='mailto:infoCOL@diamondsdirect.com'>infoCOL@diamondsdirect.com</a></li>
							<li className='chatLink' onClick={::this.openIntercom}>Chat Now</li>
						</ul>
					</li>
				</ul>
			</div>
		</div>
	}

	dfwResult() {
		return <div className='locationWrapper'>
			<div className='covidP covidPIndent covidLocation' style={{display: 'none'}}>Dallas, TX</div>
			<div className='covidP covidPIndent'>
				<ul className='primaryList'>
					<li>This location is open and operating at a limited capacity to ensure the health and safety of our customers and employees.</li>
					<li>In-store walk-ins are welcome. To request an in-store or virtual appointment for this location <span onClick={::this.scrollToContact} className='scrollLink'>click here</span>.</li>
					<li>Contactless curbside pick-up is available. Please contact us to coordinate.</li>
					<li>Our team is standing by to help ensure the Diamonds Direct experience fits your needs in these unprecedented times.
						<ul>
							<li><a href='tel:9723426663'>972-342-6663</a></li>
							<li><a href='mailto:infoDTX@diamondsdirect.com'>infoDTX@diamondsdirect.com</a></li>
							<li className='chatLink' onClick={::this.openIntercom}>Chat Now</li>
						</ul>
					</li>
				</ul>
			</div>
		</div>
	}

	ftxResult() {
		return <div className='locationWrapper'>
			<div className='covidP covidPIndent covidLocation' style={{display: 'none'}}>Frisco, TX</div>
			<div className='covidP covidPIndent'>
				<ul className='primaryList'>
					<li>This location is open and operating at a limited capacity to ensure the health and safety of our customers and employees.</li>
					<li>In-store walk-ins are welcome. To request an in-store or virtual appointment for this location <span onClick={::this.scrollToContact} className='scrollLink'>click here</span>.</li>
					<li>Contactless curbside pick-up is available. Please contact us to coordinate.</li>
					<li>Our team is standing by to help ensure the Diamonds Direct experience fits your needs in these unprecedented times.
						<ul>
							<li><a href='tel:4698504270'>469-850-4270</a></li>
							<li><a href='mailto:infoFRISCO@diamondsdirect.com'>infoFRISCO@diamondsdirect.com</a></li>
							<li className='chatLink' onClick={::this.openIntercom}>Chat Now</li>
						</ul>
					</li>
				</ul>
			</div>
		</div>
	}

	gscResult() {
		return <div className='locationWrapper'>
			<div className='covidP covidPIndent covidLocation' style={{display: 'none'}}>Greenville, SC</div>
			<div className='covidP covidPIndent'>
				<ul className='primaryList'>
					<li>This location is open and operating at a limited capacity to ensure the health and safety of our customers and employees.</li>
					<li>In-store walk-ins are welcome. To request an in-store or virtual appointment for this location <span onClick={::this.scrollToContact} className='scrollLink'>click here</span>.</li>
					<li>Contactless curbside pick-up is available. Please contact us to coordinate.</li>
					<li>Our team is standing by to help ensure the Diamonds Direct experience fits your needs in these unprecedented times.
						<ul>
							<li><a href='tel:8645015090'>864-501-5090</a></li>
							<li><a href='mailto:infoGVL@diamondsdirect.com'>infoGVL@diamondsdirect.com</a></li>
							<li className='chatLink' onClick={::this.openIntercom}>Chat Now</li>
						</ul>
					</li>
				</ul>
			</div>
		</div>
	}

	houResult() {
		return <div className='locationWrapper'>
			<div className='covidP covidPIndent covidLocation' style={{display: 'none'}}>Houston, TX</div>
			<div className='covidP covidPIndent'>
				<ul className='primaryList'>
					<li>This location is open and operating at a limited capacity to ensure the health and safety of our customers and employees.</li>
					<li>In-store walk-ins are welcome. To request an in-store or virtual appointment for this location <span onClick={::this.scrollToContact} className='scrollLink'>click here</span>.</li>
					<li>Contactless curbside pick-up is available. Please contact us to coordinate.</li>
					<li>Our team is standing by to help ensure the Diamonds Direct experience fits your needs in these unprecedented times.
						<ul>
							<li><a href='tel:3462502054'>346-250-2054</a></li>
							<li><a href='mailto:infoHOU@diamondsdirect.com'>infoHOU@diamondsdirect.com</a></li>
							<li className='chatLink' onClick={::this.openIntercom}>Chat Now</li>
						</ul>
					</li>
				</ul>
			</div>
		</div>
	}
	
	// houResult() {
	// 	return <div className='locationWrapper'>
	// 		<div className='covidP covidPIndent covidLocation' style={{display: 'none'}}>Houston, TX</div>
	// 		<div className='covidP covidPIndent'>
	// 			<ul className='primaryList'>
	// 				<li>This location is opening soon! To request an in-store or virtual appointment for this location, <span onClick={::this.scrollToContact} className='scrollLink'>click here</span>.</li>
	// 			</ul>
	// 		</div>
	// 	</div>
	// }

	indResult() {
		return <div className='locationWrapper'>
			<div className='covidP covidPIndent covidLocation' style={{display: 'none'}}>Indianapolis, IN</div>
			<div className='covidP covidPIndent'>
				<ul className='primaryList'>
					<li>This location is open and operating at a limited capacity to ensure the health and safety of our customers and employees.</li>
					<li>In-store walk-ins are welcome. To request an in-store or virtual appointment for this location <span onClick={::this.scrollToContact} className='scrollLink'>click here</span>.</li>
					<li>Contactless curbside pick-up is available. Please contact us to coordinate.</li>
					<li>Our team is standing by to help ensure the Diamonds Direct experience fits your needs in these unprecedented times.
						<ul>
							<li><a href='tel:3175758555'>317-575-8555</a></li>
							<li><a href='mailto:infoindy@diamondsdirect.com'>infoindy@diamondsdirect.com</a></li>
							<li className='chatLink' onClick={::this.openIntercom}>Chat Now</li>
						</ul>
					</li>
				</ul>
			</div>
		</div>
	}

	jaxResult() {
		return <div className='locationWrapper'>
			<div className='covidP covidPIndent covidLocation' style={{display: 'none'}}>Jacksonville, FL</div>
			<div className='covidP covidPIndent'>
				<ul className='primaryList'>
					<li>This location is open and operating at a limited capacity to ensure the health and safety of our customers and employees.</li>
					<li>In-store walk-ins are welcome. To request an in-store or virtual appointment for this location <span onClick={::this.scrollToContact} className='scrollLink'>click here</span>.</li>
					<li>Contactless curbside pick-up is available. Please contact us to coordinate.</li>
					<li>Our team is standing by to help ensure the Diamonds Direct experience fits your needs in these unprecedented times.
						<ul>
							<li><a href='tel:9045155959'>904-515-5959</a></li>
							<li><a href='mailto:infoJAX@diamondsdirect.com'>infoJAX@diamondsdirect.com</a></li>
							<li className='chatLink' onClick={::this.openIntercom}>Chat Now</li>
						</ul>
					</li>
				</ul>
			</div>
		</div>
	}

	kcyResult() {
		return <div className='locationWrapper'>
			<div className='covidP covidPIndent covidLocation' style={{display: 'none'}}>Kansas City, KS</div>
			<div className='covidP covidPIndent'>
				<ul className='primaryList'>
					<li>This location is open and operating at a limited capacity to ensure the health and safety of our customers and employees.</li>
					<li>In-store walk-ins are welcome. To request an in-store or virtual appointment for this location <span onClick={::this.scrollToContact} className='scrollLink'>click here</span>.</li>
					<li>Contactless curbside pick-up is available. Please contact us to coordinate.</li>
					<li>Our team is standing by to help ensure the Diamonds Direct experience fits your needs in these unprecedented times.
						<ul>
							<li><a href='tel:9133121660'>913-312-1660</a></li>
							<li><a href='mailto:infoksc@diamondsdirect.com'>infoksc@diamondsdirect.com</a></li>
							<li className='chatLink' onClick={::this.openIntercom}>Chat Now</li>
						</ul>
					</li>
				</ul>
			</div>
		</div>
	}

	pitResult() {
		return <div className='locationWrapper'>
			<div className='covidP covidPIndent covidLocation' style={{display: 'none'}}>Pittsburgh, PA</div>
			<div className='covidP covidPIndent'>
				<ul className='primaryList'>
					<li>This location is open and operating at a limited capacity to ensure the health and safety of our customers and employees.</li>
					<li>In-store walk-ins are welcome. To request an in-store or virtual appointment for this location <span onClick={::this.scrollToContact} className='scrollLink'>click here</span>.</li>
					<li>Contactless curbside pick-up is available. Please contact us to coordinate.</li>
					<li>Our team is standing by to help ensure the Diamonds Direct experience fits your needs in these unprecedented times.
						<ul>
							<li><a href='tel:4128379070'>412-837-9070</a></li>
							<li><a href='mailto:infoPITT@diamondsdirect.com'>infoPITT@diamondsdirect.com</a></li>
							<li className='chatLink' onClick={::this.openIntercom}>Chat Now</li>
						</ul>
					</li>
				</ul>
			</div>
		</div>
	}

	// pitResult() {
	// 	return <div className='locationWrapper'>
	// 		<div className='covidP covidPIndent covidLocation' style={{display: 'none'}}>Pittsburgh, PA</div>
	// 		<div className='covidP covidPIndent'>
	// 			<ul className='primaryList'>
	// 				<li>This location is opening soon! To request an in-store or virtual appointment for this location, <span onClick={::this.scrollToContact} className='scrollLink'>click here</span>.</li>
	// 			</ul>
	// 		</div>
	// 	</div>
	// }

	nolResult() {
		return <div className='locationWrapper'>
			<div className='covidP covidPIndent covidLocation' style={{display: 'none'}}>New Orleans, LA</div>
			<div className='covidP covidPIndent'>
				<ul className='primaryList'>
					<li>This location is open and operating at a limited capacity to ensure the health and safety of our customers and employees.</li>
					<li>In-store walk-ins are welcome. To request an in-store or virtual appointment for this location <span onClick={::this.scrollToContact} className='scrollLink'>click here</span>.</li>
					<li>Contactless curbside pick-up is available. Please contact us to coordinate.</li>
					<li>Our team is standing by to help ensure the Diamonds Direct experience fits your needs in these unprecedented times.
						<ul>
							<li><a href='tel:5043833900'>504-383-3900</a></li>
							<li><a href='mailto:infoNOLA@diamondsdirect.com'>infoNOLA@diamondsdirect.com</a></li>
							<li className='chatLink' onClick={::this.openIntercom}>Chat Now</li>
						</ul>
					</li>
				</ul>
			</div>
		</div>
	}

	ralResult() {
		return <div className='locationWrapper'>
			<div className='covidP covidPIndent covidLocation' style={{display: 'none'}}>Raleigh, NC</div>
			<div className='covidP covidPIndent'>
				<ul className='primaryList'>
					<li>This location is open and operating at a limited capacity to ensure the health and safety of our customers and employees.</li>
					<li>In-store walk-ins are welcome. To request an in-store or virtual appointment for this location <span onClick={::this.scrollToContact} className='scrollLink'>click here</span>.</li>
					<li>Contactless curbside pick-up is available. Please contact us to coordinate.</li>
					<li>Our team is standing by to help ensure the Diamonds Direct experience fits your needs in these unprecedented times.
						<ul>
							<li><a href='tel:9195712881'>919-571-2881</a></li>
							<li><a href='mailto:inforal@diamondsdirect.com'>inforal@diamondsdirect.com</a></li>
							<li className='chatLink' onClick={::this.openIntercom}>Chat Now</li>
						</ul>
					</li>
				</ul>
			</div>
		</div>
	}

	rvaResult() {
		return <div className='locationWrapper'>
			<div className='covidP covidPIndent covidLocation' style={{display: 'none'}}>Richmond, VA</div>
			<div className='covidP covidPIndent'>
				<ul className='primaryList'>
					<li>This location is open and operating at a limited capacity to ensure the health and safety of our customers and employees.</li>
					<li>In-store walk-ins are welcome. To request an in-store or virtual appointment for this location <span onClick={::this.scrollToContact} className='scrollLink'>click here</span>.</li>
					<li>Contactless curbside pick-up is available. Please contact us to coordinate.</li>
					<li>Our team is standing by to help ensure the Diamonds Direct experience fits your needs in these unprecedented times.
						<ul>
							<li><a href='tel:8049670500'>804-967-0500</a></li>
							<li><a href='mailto:infoRIC@diamondsdirect.com'>infoRIC@diamondsdirect.com</a></li>
							<li className='chatLink' onClick={::this.openIntercom}>Chat Now</li>
						</ul>
					</li>
				</ul>
			</div>
		</div>
	}

	stlResult() {
		return <div className='locationWrapper'>
			<div className='covidP covidPIndent covidLocation' style={{display: 'none'}}>St. Louis, MO</div>
			<div className='covidP covidPIndent'>
				<ul className='primaryList'>
					<li>This location is open and operating at a limited capacity to ensure the health and safety of our customers and employees.</li>
					<li>In-store walk-ins are welcome. To request an in-store or virtual appointment for this location <span onClick={::this.scrollToContact} className='scrollLink'>click here</span>.</li>
					<li>Contactless curbside pick-up is available. Please contact us to coordinate.</li>
					<li>Our team is standing by to help ensure the Diamonds Direct experience fits your needs in these unprecedented times.
						<ul>
							<li><a href='tel:3149423777'>314-942-3777</a></li>
							<li><a href='mailto:infoSTL@diamondsdirect.com'>infoSTL@diamondsdirect.com</a></li>
							<li className='chatLink' onClick={::this.openIntercom}>Chat Now</li>
						</ul>
					</li>
				</ul>
			</div>
		</div>
	}

	slcResult() {
		return <div className='locationWrapper'>
			<div className='covidP covidPIndent covidLocation' style={{display: 'none'}}>Salt Lake City, UT</div>
			<div className='covidP covidPIndent'>
				<ul className='primaryList'>
					<li>Virtual and remote shopping services are still available for this location. <a href='/virtual'>Click here to initiate an appointment</a>.</li>
					<li>Free shipping is available for purchases made online and via phone.</li>
					<li>Free shipping is available for select completed orders and repairs. To learn if your order qualifies for shipping, please email us at <a href='mailto:infoSLC@diamondsdirect.com'>infoSLC@diamondsdirect.com</a>.</li>
				</ul>
			</div>
		</div>
	}

	sanResult() {
		return <div className='locationWrapper'>
			<div className='covidP covidPIndent covidLocation' style={{display: 'none'}}>San Antonio, TX</div>
			<div className='covidP covidPIndent'>
				<ul className='primaryList'>
					<li>This location is open and operating at a limited capacity to ensure the health and safety of our customers and employees.</li>
					<li>In-store walk-ins are welcome. To request an in-store or virtual appointment for this location <span onClick={::this.scrollToContact} className='scrollLink'>click here</span>.</li>
					<li>Contactless curbside pick-up is available. Please contact us to coordinate.</li>
					<li>Our team is standing by to help ensure the Diamonds Direct experience fits your needs in these unprecedented times.
						<ul>
							<li><a href='tel:2102479197'>210-247-9197</a></li>
							<li><a href='mailto:infoSAT@diamondsdirect.com'>infoSAT@diamondsdirect.com</a></li>
							<li className='chatLink' onClick={::this.openIntercom}>Chat Now</li>
						</ul>
					</li>
				</ul>
			</div>
		</div>
	}

	vabResult() {
		return <div className='locationWrapper'>
			<div className='covidP covidPIndent covidLocation' style={{display: 'none'}}>Virginia Beach, VA</div>
			<div className='covidP covidPIndent'>
				<ul className='primaryList'>
					<li>This location is open and operating at a limited capacity to ensure the health and safety of our customers and employees.</li>
					<li>In-store walk-ins are welcome. To request an in-store or virtual appointment for this location <span onClick={::this.scrollToContact} className='scrollLink'>click here</span>.</li>
					<li>Contactless curbside pick-up is available. Please contact us to coordinate.</li>
					<li>Our team is standing by to help ensure the Diamonds Direct experience fits your needs in these unprecedented times.
						<ul>
							<li><a href='tel:7578370288'>757-837-0288</a></li>
							<li><a href='mailto:infoVAB@diamondsdirect.com'>infoVAB@diamondsdirect.com</a></li>
							<li className='chatLink' onClick={::this.openIntercom}>Chat Now</li>
						</ul>
					</li>
				</ul>
			</div>
		</div>
	}


	nullResult() {
		return <div className='locationWrapper'>
			<div className='covidP covidPIndent' style={{textAlign: 'center', display: 'none'}}>Select a location to get further details</div>
		</div>
	}

	changeViewLocation(evt) {
		this.setState({
			dropdownValue: evt.target.value,
		}, () => {
			console.log(this.state.dropdownValue);
		});
	}

	isDrawerOpen(key) {
		return this.state.openDrawers.includes(key);
	}

	toggleDrawer(key) {
		let clone = this.cloneArray(this.state.openDrawers);
	    let i = this.state.openDrawers.indexOf(key);

	    if(i === -1) {
			clone.push(key);
		} else {
			clone.splice(i, 1);
	    }
	    this.setState({ openDrawers: clone });
	}

	drawerIndicator(key) {
		if(this.isDrawerOpen(key)) {
			return '-';
		} else {
			return '+';
		}
	}

	cloneArray(source) {
		let result = [];
		for(let n = 0; n < source.length; n++) {
			result[n] = source[n];
		}
		return result;
	}

	scrollToContact() {
		scrollToComponent(this.covidSection, {
      offset: 0, 
      align: 'middle', 
      duration: 1000, 
      ease: 'inOutCube',
    });
	}

	toggleFormOpen() {
    this.setState({ formOpen: !this.state.formOpen });
  }

	render() {
		return <div className='Covid19'>
			<div className="promoBanner">
				<img className='desktop600' src="https://ddw2.diamondsdirect.com/img/promopages/covid19/banners/covid_banner.jpg" alt="Diamonds Direct COVID-19 Updates" />
				<img className='mobile600' src="https://ddw2.diamondsdirect.com/img/promopages/covid19/banners/covid_banner_m.jpg" alt="Diamonds Direct COVID-19 Updates" />
			</div>
			
			<div className="promoBody">
				<div className='titleArea'>
					<div className='mainTitle'>COVID-19 Protocols</div>
					<div className='titleCopy'>As your trusted jeweler, we are taking every measure to ensure you feel safe and comfortable shopping with us. We are following all state and local mandates regarding public health and safety to ensure the health and wellbeing of our customers and employees. Here is how we are taking action:</div>
					<div className='titleCopy'><strong>Curbside Pick-Up:</strong> Curbside pick-up is available at all Diamonds Direct locations. To coordinate your pick up, please contact your <span className='titleLink' onClick={() => this.internalNav('locations')}>local showroom</span>.</div>
					<div className='titleCopy'><strong>In-Store Appointments:</strong> Requesting an in-store appointment is a great way for our experts to help you shop with us efficiently and safely. Though appointments are not required, they help us meet your personal needs while maintaining social distancing in our showroom. To request an in-store appointment, <span className='titleLink' onClick={::this.scrollToContact}>click here</span>.</div>
				</div>

				<div className='bodyArea'>
					<div className='iconArea'>
						<div className='bodyTitle'>We are operating our showrooms with recommended health and safety protocols, including:</div>
						<div className='iconWrapper'>
							<div className='iconItem'>
								<div className='itemIcon'>
									<img src='https://ddw2.diamondsdirect.com/img/promopages/covid19/svg/wellness.svg' />
								</div>
								<div className='itemTitle'>Wellness Checks</div>
								<div className='itemBody'>All experts and team members are encouraged to conduct self-wellness checks prior to entering our workspaces. If employees are not feeling well, they are encouraged to stay home.</div>
							</div>
							<div className='iconItem'>
								<div className='itemIcon'>
									<img src='https://ddw2.diamondsdirect.com/img/promopages/covid19/svg/mask.svg' />
								</div>
								<div className='itemTitle'>Wearing Masks</div>
								<div className='itemBody'>For the safety of the Diamonds Direct team and our guests, all staff will be wearing masks for all of our protection. We kindly ask that our customers wear face coverings as well. We appreciate your cooperation!</div>
							</div>
							<div className='iconItem'>
								<div className='itemIcon'>
									<img src='https://ddw2.diamondsdirect.com/img/promopages/covid19/svg/hand.svg' />
								</div>
								<div className='itemTitle'>Hand Sanitizing</div>
								<div className='itemBody'>Experts and team members are encouraged to frequently wash their hands for 20 seconds or more throughout the day. Hand sanitizing stations are available in all showrooms for employees and guests as well.</div>
							</div>
							<div className='iconItem'>
								<div className='itemIcon'>
									<img src='https://ddw2.diamondsdirect.com/img/promopages/covid19/svg/cleaning.svg' />
								</div>
								<div className='itemTitle'>Enhanced Cleaning</div>
								<div className='itemBody'>Our showrooms have increased their sanitation and disinfecting protocols. All high-touch surfaces are thoroughly sanitized before opening, throughout the business day, and after closing to ensure the safety of our customers and team.</div>
							</div>
							<div className='iconItem'>
								<div className={'itemIcon rulerIcon'}>
									<img src='https://ddw2.diamondsdirect.com/img/promopages/covid19/svg/distancing.svg' />
								</div>
								<div className='itemTitle'>Social Distancing</div>
								<div className='itemBody'>Team members and guests are encouraged to maintain a social distance of 6 feet or more where possible in our showrooms.</div>
							</div>
							<div className='iconItem'>
								<div className='itemIcon'>
									<img src='https://ddw2.diamondsdirect.com/img/promopages/covid19/svg/shopping.svg' />
								</div>
								<div className='itemTitle'>Contactless Shopping</div>
								<div className='itemBody'>Experience the Diamonds Direct difference from anywhere at www.diamondsdirect.com. Connect with a diamond expert using our video chat and virtual appointment tools.</div>
							</div>
						</div>
					</div>
					<div className='storeArea'>
						<div className='bodyTitle'>View operational updates for the location nearest you:</div>
						<div className='storeDropDownWrapper'>
							<RhinoSelect
				                selectClass={'contactSelect'}
				                value={this.state.dropdownValue}
				                options={this.state.locations}
				                changeMethod={(evt) => this.changeViewLocation(evt)} />
						</div>
						<div className='storeResultsWrapper'>
							{!this.state.dropdownValue ?
								<div>{this.nullResult()}</div> :
								<div>{this.showStoreSection()}</div>
							}
						</div>
					</div>
				</div>
			</div>

			<div className='covidContact' ref={(div) => { this.covidSection = div; }}>

				<div className='covidTitle'>Connect with an Expert</div>
				<div className='covidCopy' style={{display: 'none'}}>Our diamond experts have the resources to assist you from the comfort of your home via live chat, video chat, text, phone call, and email. All online orders qualify for free, secure shipping and hassle-free, 30-day returns. Contactless curbside pick-up is available at all locations. To request an in-store or virtual appointment, please fill out the form below:</div>

				<div className='scheduleBody'>
	        <div className='scheduleBr'></div>
	        <div className={'sbText'}>Our diamond experts have the resources to assist you from the comfort of your home via live chat, video chat, text, phone call, and email. All online orders qualify for free, secure shipping and hassle-free, 30-day returns. Contactless curbside pick-up is available at all locations. To request an in-store or virtual appointment, please fill out the form below:</div>
	        <div className='optionsWrapper'>
	          <div className='optionItem'>
	            <div className='optionImg'>
	              <img src='https://ddw2.diamondsdirect.com/img/contact/chat.svg' />
	            </div>
	            <div className='optionBr'></div>
	            <div className='optionTitle'>
	              <div>Chat with Live Experts Now</div>
	            </div>
	            <div className='optionButton' onClick={::this.openIntercom}>Chat Now</div>
	          </div>
	          <div className='optionItem'>
	            <div className='optionImg'>
	              <img src='https://ddw2.diamondsdirect.com/img/contact/video.svg' />
	            </div>
	            <div className='optionBr'></div>
	            <div className='optionTitle'>
	              <div>Live Video with Experts Now</div>
	            </div>
	            <div className='optionButton' onClick={() => this.internalNav('video-chat')}>Video Chat Now</div>
	          </div>
	          <div className='optionItem'>
	            <div className='optionImg'>
	              <img src='https://ddw2.diamondsdirect.com/img/contact/appt.svg' />
	            </div>
	            <div className='optionBr'></div>
	            <div className='optionTitle'>
	              <div>In-Store Appointment</div>
	            </div>
	            <div className={this.state.formOpen ? 'optionButton selected' : 'optionButton'} onClick={::this.toggleFormOpen}>Request Appointment</div>
	          </div>
	        </div>
	        <div className={this.state.formOpen ? 'sbFormWrapper openForm' : 'sbFormWrapper'}>
	  				<div className='contactPageForm'>
	            <div className='formBody'>
	              <div className='formRow'>
	                
	                <div className='oneHalfSection'>
	                  <input 
	                    className={this.state.errorName ? 'textInput error' : 'textInput'}
	                    type='text' 
	                    placeholder='Full Name&#42;'
	                    value={this.state.inputName}
	                    onChange={::this.changeName} />
	                </div>
	                <div className='oneHalfSection'>
	                  <input 
	                    className={this.state.errorEmail ? 'textInput error' : 'textInput'}
	                    type='email' 
	                    placeholder='Email Address&#42;'
	                    value={this.state.inputEmail}
	                    onChange={::this.changeEmail} />
	                </div>
	              </div>
	              <div className='formRow'>
	                <div className='oneHalfSection'>
	                  <input 
	                    className={this.state.errorPhone ? 'textInput error' : 'textInput'}
	                    type='text' 
	                    placeholder='Telephone'
	                    value={this.state.inputPhone}
	                    onChange={::this.changePhone} />
	                </div>
	                <div className='oneHalfSection'>
	                  <RhinoSelect
	                    selectClass={'contactSelect contactPageSelect'}
	                    required={true}
	                    options={this.state.locations}
	                    changeMethod={(evt) => this.changeLocation(evt)}
	                    value={this.state.inputLocation}
	                    error={this.state.errorLocation} />
	                </div>
	              </div>
	              <div className='formRow'>
	                <div className='textareaInputWrapper'>
	                  <textarea
	                    className={this.state.errorMessage ? 'textTextarea error' : 'textTextarea'}
	                    placeholder='How can we help you?'
	                    value={this.state.inputMessage}
	                    onChange={::this.changeMessage}>
	                  </textarea>
	                </div>
	              </div>
	              <div className='formRow'>
	                <div className={'submitButton actionButton'} onClick={::this.submitContactRequest}>Submit</div>
	              </div>
	            </div>
	          </div>
	        </div>
	        <div className='sbText'>We look forward to connecting with you!</div>
				</div>
			</div>
		</div>;
	}
}
export default Covid19;

function mapStateToProps(state) {
  return {

  };
}

export const Covid19Container = connect(
  mapStateToProps,
  allActionCreators
)(Covid19);


// WEBPACK FOOTER //
// ./src/components/views/promopages/covid19/Covid19.jsx